import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Constants } from 'src/@smartmanufacturing/common/constants';
import { map, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class CILMasterService {
  // tslint:disable-next-line:typedef
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetEnterpriseGroupDDL', data);
  }

  getPlantsData(data: any): Observable<any[]> {
    let params = new HttpParams().set('id', data);
    return this.http.get<any[]>(this.baseUrl + 'CIL/GetPlantByEgDDL', { params: params });
  }
  //==========================================Master Type ===========================//
  insertType(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/InsertCILMasterType', data);
  }
  updateType(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.baseUrl + 'CIL/UpdateCILMasterType', data, { headers: header });
  }

  deleteType(data: any): Observable<any[]> {
    const httpParams = new HttpParams().append('id', data);
    return this.http.post<any[]>(this.baseUrl + 'CIL/DeleteCILMasterType?' + httpParams, httpParams);
  }

  getCILTypeData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetCILTypeMasterData', data);
  }

  //==============================================End Type========================================//

  //===============================================Master Tool===================================//
  insertTool(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/InsertCILMasterTool', data);
  }
  updateTool(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/UpdateCILMasterTool', data);
  }
  deleteTool(data: any): Observable<any[]> {
    const httpParams = new HttpParams().append('id', data);
    return this.http.post<any[]>(this.baseUrl + 'CIL/DeleteCILMasterTool?' + httpParams, httpParams);
    // let params = new HttpParams().set('id', data);
    // return this.http.get<any[]>(this.baseUrl + 'CIL/DeleteCILMasterTool', { params: params });
  }

  getCILToolData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetCILToolsMasterData', data);
  }

  //===============================================Master Frequency ===================================//
  insertFrequency(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/InsertCILMasterFrequency', data);
  }
  updateFrequency(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/UpdateCILMasterFrequency', data);
  }
  deleteCILTaskData(data: any): Observable<any[]> {
    const httpParams = new HttpParams().append('id', data);
    return this.http.post<any[]>(this.baseUrl + 'CIL/DeleteCILTaskData?' + httpParams, httpParams);
    // let params = new HttpParams().set('id', data);
    // return this.http.get<any[]>(this.baseUrl + 'CIL/DeleteCILTaskData', { params: params });
  }

  getCILFrequencyData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetCILFrequencyMaster', data);
  }

  //====================================== Get Type List ===================================//
  getCILTypeList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetCilTypeDDL', data);
  }
  //====================================== Get Tool List ===================================//
  getCILToolList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetCilToolDDL', data);
  }

  //====================================== Get Frequency List ===================================//
  getCILFrequencyList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetCilFrequencyDDL', data);
  }

  //============================================== Task Master ==================================//
  insertTask(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/InsertCILTask', data);
  }
  getCILTaskData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetCILTaskData', data);
  }
  updateTask(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/UpdateCILTask', data);
  }
  deleteFrequency(data: any): Observable<any[]> {
    const httpParams = new HttpParams().append('id', data);
    return this.http.post<any[]>(this.baseUrl + 'CIL/DeleteCILMasterFrequency?' + httpParams, httpParams);
    // let params = new HttpParams().set('id', data);
    // return this.http.get<any[]>(this.baseUrl + 'CIL/DeleteCILMasterFrequency', { params: params });
  }
  updateTaskStatus(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/UpdateTaskStatus', data);
  }

  getComponentByPlantUpload(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetComponentByPlantUpload', data);
  }

  getAssemblyByPlantUpload(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetAssemblyByPlantUpload', data);
  }

  getSubAssemblyList(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'CIL/GetSubAssemblyListByAssemblyId', data);
  }

  getSubAssemblyByPlantUpload(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'CIL/GetSubAssemblyListByPlant', data);
  }
  
  getUnitByPlantUpload(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetUnitByPlantUpload', data);
  }

  getLineByPlantUpload(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetLineByPlantUpload', data);
  }

  //-----------------------------------------CIL_Master Bulk Upload---------------------------------//

   DownloadSampleExcel(): Observable<Blob> {
    const fileUrl = `${this.baseUrl}cil_bulkupload/DownloadTemplateExcel`;
    return this.http.get(fileUrl, { responseType: 'blob' }).pipe(
      catchError((error) => {
        console.error('Error downloading sample Excel:', error);
        throw new Error('Failed to download sample Excel file.');
      })
    );
   }

  CilBulkUploadFile(formData: FormData): Observable<any> {
  return this.http.post(this.baseUrl + 'cil_bulkupload/CILBulkUpload', formData, {
    responseType: 'json'
  });
}


}
